import React, {
  createContext,
  Dispatch,
  ReactNode,
  useContext,
  useReducer
} from 'react'

export const createContextHelper = <State, Action>(
  reducer: React.Reducer<State, Action>,
  initialState: State
) => {
  const Context = createContext<
    { state: State; dispatch: Dispatch<Action> } | undefined
  >(undefined)

  const useCustomContext = (): { state: State; dispatch: Dispatch<Action> } => {
    const context = useContext(Context)
    if (!context) {
      throw new Error('useCustomContext must be used within its Provider')
    }
    return context
  }

  const Provider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    return (
      <Context.Provider value={{ state, dispatch }}>
        {children}
      </Context.Provider>
    )
  }

  return { Provider, useContext: useCustomContext }
}
